import React, { useState } from "react";

function RSVP() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    attending: "yes",
  });

  const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwX-n4rfRRRa0SfNqaXkJ4I1G3njj0-IgpT0IuW1iRJvS2EabpLRXmTQDQi9aSDyF15/exec";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name.trim() || !form.email.trim()) {
      alert("Please provide at least your name and email.");
      return;
    }

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("attending", form.attending);

    try {
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        body: formData,
      });

      const resultText = await response.text();
      console.log("Apps Script response:", resultText);

      if (resultText.toLowerCase().includes("success")) {
        alert("RSVP submitted successfully!");

        setForm({
          name: "",
          email: "",
          phone: "",
          attending: "yes",
        });
      } else {
        alert("The RSVP did not save to Google Sheets.");
        console.error("Unexpected Apps Script response:", resultText);
      }
    } catch (error) {
      alert("Something went wrong while submitting the RSVP.");
      console.error("RSVP submit error:", error);
    }
  };

  return (
    <div className="page">
      <section className="section section-soft fade-up">
        <div className="section-inner">
          <h2>RSVP</h2>
          <p className="section-intro">
            Please let us know if you&apos;ll be able to celebrate with us.
          </p>

          <form className="rsvp-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <label htmlFor="name">Full Name</label>
              <input
                id="name"
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                placeholder="First and Last Name"
                required
              />
            </div>

            <div className="form-row">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="form-row">
              <label htmlFor="phone">Phone Number</label>
              <input
                id="phone"
                name="phone"
                type="tel"
                value={form.phone}
                onChange={handleChange}
                placeholder="(555) 555-5555"
              />
            </div>

            <div className="form-row">
              <label>Will you be attending?</label>
              <div className="radio-group">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="attending"
                    value="yes"
                    checked={form.attending === "yes"}
                    onChange={handleChange}
                  />
                  Yes, I&apos;ll be there
                </label>

                <label className="radio-label">
                  <input
                    type="radio"
                    name="attending"
                    value="no"
                    checked={form.attending === "no"}
                    onChange={handleChange}
                  />
                  Sorry, I can&apos;t make it
                </label>
              </div>
            </div>

            <button type="submit" className="btn-primary">
              Submit RSVP
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default RSVP;